
//日期转换
export function formartDateTime(duration, type) {
    let d = new Date(duration)
    let month = '' + (d.getMonth() + 1)
    let day = '' + d.getDate()
    let year = d.getFullYear()
    let seconds = d.getSeconds()
    let minutes = d.getMinutes()
    let hours = d.getHours()
    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    if (type) {
        if (type == 'yy-mm') {
            return ([year, month].join('-'));
        } else if (type == 'yy-mm-dd hh:mm:ss') {
            return ([year, month, day].join('-') + ' ' + hours + ':' + minutes + ':' + seconds)
        } else if (type == 'yy-mm-dd hh:mm') {
            return ([year, month, day].join('-') + ' ' + hours + ':' + minutes)
        } else {
            return ([year, month, day].join('-'))
        }
    } else {
        return ([year, month, day].join('-'))
    }
};

//表单序列化
export const serialize = data => {
    let list = [];
    Object.keys(data).forEach(ele => {
        list.push(`${ele}=${data[ele]}`)
    })
    return list.join('&');
};

/**
 * 判断是否为空
 */
export function validatenull(val) {
    if (typeof val == 'boolean') {
        return false;
    }
    if (typeof val == 'number') {
        return false;
    }
    if (val instanceof Array) {
        if (val.length == 0) return true;
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === '{}') return true;
    } else {
        if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
        return false;
    }
    return false;
}

/**
 * 对象深拷贝
 */
export const deepClone = data => {
    var type = getObjType(data);
    var obj;
    if (type === 'array') {
        obj = [];
    } else if (type === 'object') {
        obj = {};
    } else {
        //不再具有下一层次
        return data;
    }
    if (type === 'array') {
        for (var i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]));
        }
    } else if (type === 'object') {
        for (var key in data) {
            obj[key] = deepClone(data[key]);
        }
    }
    return obj;
};

/**
 * 判断变量类型
 */
export const getObjType = obj => {
    var toString = Object.prototype.toString;
    var map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    };
    if (obj instanceof Element) {
        return 'element';
    }
    return map[toString.call(obj)];
};